module.exports = __webpack_public_path__ + "static/media/heart6.6628b0e5.png";